import { NetworkConstants } from "./NetworkConstants";

export const getYPONetworksData = (data) => {
  const cardData = {};
  if (data) {
    data.forEach((community) => {
      const { communityType, name, communityId, redirectUrl } = community;

      if (!cardData[communityType]) {
        cardData[communityType] = [];
      }

      cardData[communityType].push({
        title: name,
        communityId,
        imageUrl: community.communityImageURL,
        fallbackImageURL: community.fallbackImageURL,
        recordTypeName: community.recordTypeName,
        communityType: community.communityType,
      });
    });

    let modifiedCardData = Object.entries(cardData).map(([type, cards]) => {
      let title = type === NetworkConstants.COMMUNITIES
        ? NetworkConstants.YPO_COMMUNITIES
        : `YPO ${type} Networks`;
    
      if (title === 'YPO Business Networks') {
        title += ` : <span class="member-only-note"> Available to members only</span>`;
      }
    
      return {
        title,
        cards,
      };
    });

    modifiedCardData.sort((a, b) => {
      if (a.title === NetworkConstants.YPO_COMMUNITIES && b.title !== NetworkConstants.YPO_COMMUNITIES) return 1;
      if (a.title !== NetworkConstants.YPO_COMMUNITIES && b.title === NetworkConstants.YPO_COMMUNITIES) return -1;
      
      // Otherwise, sort alphabetically
      return a.title.localeCompare(b.title);
    });

    return modifiedCardData;
  }

  return [];
};
